var quizQuestions = [
  ["question_freegift", true],
  ["question_freegift_tiktok", false],
  ["question_unhappy", true],
  ["question_currentap", true],
  ["question_wheresweat", true],
  ["question_mostsweat", false],
  ["question_smell", false],
  ["question_smell2", false],
  ["question_makeup", false],
  ["question_gender", false],
  ["question_subscription", true],
  ["question_email", true],
];

//tiktok quiz
$(document).ready(function () {
  if (tiktok_quiz === true) {
    document.getElementsByClassName("quiz_slide")[0].classList.add("inactive");
    document
      .getElementsByClassName("quiz_slide")[1]
      .classList.remove("inactive");
    document
      .getElementsByClassName("gift_block")[0]
      .classList.remove("answer_selected");
    document
      .getElementsByClassName("gift_block")[3]
      .classList.add("answer_selected");
    document.getElementById("timer_image").src =
      "https://cdn.shopify.com/s/files/1/0335/1622/4645/files/bag.jpg?v=1658779317";
    quizQuestions = [
      ["question_freegift", false],
      ["question_freegift_tiktok", true],
      ["question_unhappy", false],
      ["question_currentap", false],
      ["question_wheresweat", true],
      ["question_sweatslider", false],
      ["question_mostsweat", false],
      ["question_smell", false],
      ["question_smell2", false],
      ["question_makeup", false],
      ["question_gender", false],
      ["question_subscription", true],
      ["question_email", true],
    ];
  }
});

const recommendedProducts = [];
var newIndex = undefined;

function nextQuestion(parentID) {
  addFutureQuestions();
  //console.log(parentID)
  for (i = 0; i < quizQuestions.length; i++) {
    if (quizQuestions[i][0] == parentID) {
      newIndex = i + 1;
      for (j = newIndex; j < quizQuestions.length; j++) {
        if (quizQuestions[j][1] === true) {
          newIndex = j;
          break;
        } else {
          //GO TO RESULTS... NO QUESTIONS LEFT WITH TRUE
        }
      }
    }
  }
  var nextID = quizQuestions[newIndex][0];
  gtag("event", "quiz_next_question", { next: nextID });
  //stores current Q for if page is reloaded
  sessionStorage.setItem("currentQ", nextID);
  history.pushState(null, document.title, location.pathname + "#" + nextID);
  setTimeout(function () {
    document.getElementById(parentID).classList.add("inactive");
    document.getElementById(nextID).classList.remove("inactive");
    window.scrollTo(0, 0);
    document.getElementById(nextID).scrollTop = 0;
    document.body.scrollTop = 0;

    //HANDLES PROGRESS BAR WIDTH
    var quizLength = quizQuestions.length;
    var progressWidth = ((newIndex + 1) / quizLength) * 100;
    //console.log(progressWidth);
    document.getElementById("quiz_progress_active").style.width =
      progressWidth + "%";

    //handles show/hide of X button
    if (newIndex == 0 || newIndex == quizQuestions.length - 1) {
      document.getElementById("quiz-close-icon").style.opacity = 1;
    } else {
      document.getElementById("quiz-close-icon").style.opacity = 0;
    }
  }, 500);
}

//Session storage array
var quizStorage = [];

function selectedAnswer(answer, gift_image) {
  //Changes answer selected class when clicked & removes other if it's a single choice question
  if (answer.parentElement.parentElement.classList.contains("one_answer")) {
    if (answer.nextElementSibling) {
      answer.classList.add("answer_selected");
      answer.nextElementSibling.classList.remove("answer_selected");
    } else {
      answer.classList.add("answer_selected");
      answer.previousElementSibling.classList.remove("answer_selected");
    }
  } else {
    answer.classList.toggle("answer_selected");
  }

  //Sesison storage of answer_selected
  var allSelectedAnswers = document.getElementsByClassName("answer_selected");
  //sets the quiz Storage function to hold answers
  var quizStorage = [];
  for (i = 0; i < allSelectedAnswers.length; i++) {
    quizStorage.push(allSelectedAnswers[i].id);
  }

  sessionStorage.setItem("answers", JSON.stringify(quizStorage));
  var quizAnswers = JSON.parse(sessionStorage.getItem("answers"));
  console.log(quizAnswers);

  //Specific logic that runs if you're selecting a free gift
  if (answer.classList.contains("gift_block")) {
    //Behave differently based on whether you just activated this selection or have cleared all selections
    if (answer.classList.contains("answer_selected")) {
      //So you've just selected this - set the corresponding gift image and clear the other selection
      document.getElementById("timer_image").src = gift_image;
      //Note that this code was updated 7/26/23 to allow for more than 2 gift options
      let quizGiftBlock = document.getElementsByClassName("gift_block");
      for (let i = 0; i < quizGiftBlock.length; i++) {
        if (quizGiftBlock[i] != answer) {
          quizGiftBlock[i].classList.remove("answer_selected");
        }
      }
    } else {
      document.getElementById("timer_image").src =
        "//cdn.shopify.com/s/files/1/0335/1622/4645/t/111/assets/freegift_default_200x.png?v=6815870730005612561";
    }
  }
  //If any answers are selected, enable the NEXT button - if no answers are selected, disable the button
  all_answers = answer.parentElement.children;
  for (i = 0; i < all_answers.length; i++) {
    if (all_answers[i].classList.contains("answer_selected")) {
      //At least one answer selected - enable the button
      answer.parentElement.nextElementSibling.children[0].disabled = false;
      return;
    }
  }
  //No answers are selected - disable the button
  answer.parentElement.nextElementSibling.children[0].disabled = true;
}

function addFutureQuestions() {
  var selectedAnswers = document.getElementsByClassName("answer_selected");
  console.log(selectedAnswers);
  for (i = 0; i < selectedAnswers.length; i++) {
    if (selectedAnswers[i].dataset.question) {
      var newQuestion = selectedAnswers[i].dataset.question;
      console.log(newQuestion);
      for (j = 0; j < quizQuestions.length; j++) {
        if (quizQuestions[j][0] == newQuestion) {
          quizQuestions[j][1] = true;
        }
      }
    }
  }
}

function goToCart() {
  // For each div in "question_wheresweat" check if class = answer_selected;
  var selectedAnswers = document.getElementsByClassName("answer_selected");
  console.log(selectedAnswers);
  for (i = 1; i < selectedAnswers.length; i++) {
    if (selectedAnswers[i].dataset.product) {
      console.log(selectedAnswers[i].dataset.product);
      recommendedProducts.push(selectedAnswers[i].dataset.product);
      //add matte collection
      if (selectedAnswers[i].dataset.product == "CP-22") {
        if (quizMatteCollection == true) {
          recommendedProducts[recommendedProducts.length - 1] = "CP-ADM";
        }
      }
      //replaces scalp w scalp regi -- this is live
      if (selectedAnswers[i].dataset.product == "CP-17") {
        if (scalpQuiz == true) {
          recommendedProducts[recommendedProducts.length - 1] = "CP-SR-KIT";
        }
      }
    }
  }
  // checks if the underarm was selected on the quiz, if not an underarm stick will be added
  if (alwaysUA === true) {
    recommendedProducts.unshift("CP-UA-FP");
    for (i = 1; i < selectedAnswers.length; i++) {
      if (selectedAnswers[i].dataset.product) {
        if (selectedAnswers[i].dataset.product == "CP-10-15") {
          recommendedProducts.shift();
        }
      }
    }
  }
  gtag("event", "finish_quiz", { recs: recommendedProducts });

  //sends email to klaviyo
  var quizEmail = document.getElementById("quiz_email_input").value;
  console.log(quizEmail);

  /*var settings = {
    async: true,
    crossDomain: true,
    url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
    method: "POST",
    headers: {
      "content-type": "application/x-www-form-urlencoded",
      "cache-control": "no-cache",
    },
    data: {
      g: "VbwEAu",
      $fields: "$source",
      email: quizEmail,
      $source: "Quiz",
    },
  };
  $.ajax(settings).done(function (response) {
      console.log(response);
    });*/
  fetch("https://manage.kmail-lists.com/ajax/subscriptions/subscribe", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      },
      body: new URLSearchParams({
        g: "VbwEAu",         // List ID
        email: quizEmail,
        $source: "Quiz"      // Custom source
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log("Subscription success:", data);
      // Optional: handle success UI update
    })
    .catch(error => {
      console.error("Subscription error:", error);
      // Optional: handle error UI
    });

  // send email directly to attentive
  /*if (quizEmail && quizEmail != "" && quizEmail != null) {
    fetch("https://carpequiz.free.beeceptor.com", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email: quizEmail }),
    })
      .then((response) => response.json())
      .then((data) => console.log("Success:", data))
      .catch((error) => console.error("Error:", error));

    $.ajax(settings).done(function (response) {
      console.log(response);
    });
  }*/

  //default sub quiz
  if (subscriptionDefaultQuiz === true) {
    var urlArray = [];
    console.log(recommendedProducts);
    for (var q = 0; q < recommendedProducts.length; q++) {
      //loops through each sku and finds selling plan if it's a UA item

      //adds item_total property to regimen & face primer & scalp regimen
      if (recommendedProducts[q].includes("CP-CU")) {
        urlArray[q] =
          "items[" +
          q +
          "][id]=" +
          carpe_variants[recommendedProducts[q]].id +
          "&items[" +
          q +
          "][selling_plan]=" +
          carpe_variants[recommendedProducts[q]].selling_plan_allocations[
            intervalIndex
          ].selling_plan_id +
          "&items[" +
          q +
          "][quantity]=1&items[" +
          q +
          "][properties[item_total]]=4";
      } else if (recommendedProducts[q].includes("CP-22")) {
        urlArray[q] =
          "items[" +
          q +
          "][id]=" +
          carpe_variants[recommendedProducts[q]].id +
          "&items[" +
          q +
          "][selling_plan]=" +
          carpe_variants[recommendedProducts[q]].selling_plan_allocations[
            intervalIndex
          ].selling_plan_id +
          "&items[" +
          q +
          "][quantity]=1&items[" +
          q +
          "][properties[item_total]]=2";
      } else if (recommendedProducts[q].includes("SR-KIT")) {
        urlArray[q] =
          "items[" +
          q +
          "][id]=" +
          carpe_variants[recommendedProducts[q]].id +
          "&items[" +
          q +
          "][selling_plan]=" +
          carpe_variants[recommendedProducts[q]].selling_plan_allocations[
            intervalIndex
          ].selling_plan_id +
          "&items[" +
          q +
          "][quantity]=1&items[" +
          q +
          "][properties[item_total]]=2";
      } else if (recommendedProducts[q].includes("CP-ADM")) {
        urlArray[q] =
          "items[" +
          q +
          "][id]=" +
          carpe_variants[recommendedProducts[q]].id +
          "&items[" +
          q +
          "][selling_plan]=" +
          carpe_variants[recommendedProducts[q]].selling_plan_allocations[
            intervalIndex
          ].selling_plan_id +
          "&items[" +
          q +
          "][quantity]=1&items[" +
          q +
          "][properties[item_total]]=4";
      } else {
        urlArray[q] =
          "items[" +
          q +
          "][id]=" +
          carpe_variants[recommendedProducts[q]].id +
          "&items[" +
          q +
          "][selling_plan]=" +
          carpe_variants[recommendedProducts[q]].selling_plan_allocations[
            intervalIndex
          ].selling_plan_id +
          "&items[" +
          q +
          "][quantity]=1";
        console.log(urlArray[q]);
      }
    }
    console.log(urlArray);
    if (selectedAnswers[0].dataset.product) {
      //fixes free gift undefined bug
      var urlEnd =
        "items[" +
        recommendedProducts.length +
        "][id]=" +
        selectedAnswers[0].dataset.product +
        "&items[" +
        recommendedProducts.length +
        "][quantity]=1"; //This adds the free gift to the first slot
    } else {
      var urlEnd =
        "items[" +
        recommendedProducts.length +
        "][id]=" +
        39794201428101 +
        "&items[" +
        recommendedProducts.length +
        "][quantity]=1"; //This adds the free gift to the first slot
    }
    var url = "/cart/add?";
    var urlFinalArray = "";
    for (var p = 0; p < urlArray.length; p++) {
      var urlFinalArray = urlFinalArray + urlArray[p] + "&"; //final url for sub
      console.log(url);
    }
    url = url + urlFinalArray + urlEnd;
  } else {
    //tests whether the subscription option was chosen to make different link
    if (selectedAnswers[selectedAnswers.length - 1].dataset.subscription) {
      //(SUBSCRIPTION)
      var urlArray = [];
      console.log(recommendedProducts);
      for (var q = 0; q < recommendedProducts.length; q++) {
        //loops through each sku and finds selling plan if it's a UA item

        //adds item_total property to regimen & face primer & scalp regimen
        if (recommendedProducts[q].includes("CP-CU")) {
          urlArray[q] =
            "items[" +
            q +
            "][id]=" +
            carpe_variants[recommendedProducts[q]].id +
            "&items[" +
            q +
            "][selling_plan]=" +
            carpe_variants[recommendedProducts[q]].selling_plan_allocations[
              intervalIndex
            ].selling_plan_id +
            "&items[" +
            q +
            "][quantity]=1&items[" +
            q +
            "][properties[item_total]]=4";
        } else if (recommendedProducts[q].includes("CP-22")) {
          urlArray[q] =
            "items[" +
            q +
            "][id]=" +
            carpe_variants[recommendedProducts[q]].id +
            "&items[" +
            q +
            "][selling_plan]=" +
            carpe_variants[recommendedProducts[q]].selling_plan_allocations[
              intervalIndex
            ].selling_plan_id +
            "&items[" +
            q +
            "][quantity]=1&items[" +
            q +
            "][properties[item_total]]=2";
        } else if (recommendedProducts[q].includes("SR-KIT")) {
          urlArray[q] =
            "items[" +
            q +
            "][id]=" +
            carpe_variants[recommendedProducts[q]].id +
            "&items[" +
            q +
            "][selling_plan]=" +
            carpe_variants[recommendedProducts[q]].selling_plan_allocations[
              intervalIndex
            ].selling_plan_id +
            "&items[" +
            q +
            "][quantity]=1&items[" +
            q +
            "][properties[item_total]]=2";
        } else if (recommendedProducts[q].includes("CP-ADM")) {
          urlArray[q] =
            "items[" +
            q +
            "][id]=" +
            carpe_variants[recommendedProducts[q]].id +
            "&items[" +
            q +
            "][selling_plan]=" +
            carpe_variants[recommendedProducts[q]].selling_plan_allocations[
              intervalIndex
            ].selling_plan_id +
            "&items[" +
            q +
            "][quantity]=1&items[" +
            q +
            "][properties[item_total]]=4";
        } else {
          urlArray[q] =
            "items[" +
            q +
            "][id]=" +
            carpe_variants[recommendedProducts[q]].id +
            "&items[" +
            q +
            "][selling_plan]=" +
            carpe_variants[recommendedProducts[q]].selling_plan_allocations[
              intervalIndex
            ].selling_plan_id +
            "&items[" +
            q +
            "][quantity]=1";
          console.log(urlArray[q]);
        }
      }
      console.log(urlArray);
      if (selectedAnswers[0].dataset.product) {
        //fixes free gift undefined bug
        var urlEnd =
          "items[" +
          recommendedProducts.length +
          "][id]=" +
          selectedAnswers[0].dataset.product +
          "&items[" +
          recommendedProducts.length +
          "][quantity]=1"; //This adds the free gift to the first slot
      } else {
        var urlEnd =
          "items[" +
          recommendedProducts.length +
          "][id]=" +
          39794201428101 +
          "&items[" +
          recommendedProducts.length +
          "][quantity]=1"; //This adds the free gift to the first slot
      }
      var url = "/cart/add?";
      var urlFinalArray = "";
      for (var p = 0; p < urlArray.length; p++) {
        var urlFinalArray = urlFinalArray + urlArray[p] + "&"; //final url for sub
        console.log(url);
      }
      //convert goal for answering YES to sub question
      window._conv_q = window._conv_q || [];
      _conv_q.push(["triggerConversion", "100323289"]);

      url = url + urlFinalArray + urlEnd;
    } else {
      // (NO SUBSCRIPTION)

      var urlArray = [];
      console.log(recommendedProducts);
      for (var q = 0; q < recommendedProducts.length; q++) {
        //adds item_total property to regimen & face primer & scalp regimen
        if (recommendedProducts[q].includes("CP-CU")) {
          urlArray[q] =
            "items[" +
            q +
            "][id]=" +
            carpe_variants[recommendedProducts[q]].id +
            "&items[" +
            q +
            "][quantity]=1&items[" +
            q +
            "][properties[item_total]]=4";
        } else if (recommendedProducts[q].includes("CP-22")) {
          urlArray[q] =
            "items[" +
            q +
            "][id]=" +
            carpe_variants[recommendedProducts[q]].id +
            "&items[" +
            q +
            "][quantity]=1&items[" +
            q +
            "][properties[item_total]]=2";
        } else if (recommendedProducts[q].includes("SR-KIT")) {
          urlArray[q] =
            "items[" +
            q +
            "][id]=" +
            carpe_variants[recommendedProducts[q]].id +
            "&items[" +
            q +
            "][quantity]=1&items[" +
            q +
            "][properties[item_total]]=2";
        } else if (recommendedProducts[q].includes("CP-ADM")) {
          urlArray[q] =
            "items[" +
            q +
            "][id]=" +
            carpe_variants[recommendedProducts[q]].id +
            "&items[" +
            q +
            "][quantity]=1&items[" +
            q +
            "][properties[item_total]]=4";
        } else {
          urlArray[q] =
            "items[" +
            q +
            "][id]=" +
            carpe_variants[recommendedProducts[q]].id +
            "&items[" +
            q +
            "][quantity]=1";
          console.log(urlArray[q]);
        }
      }
      console.log(urlArray);
      if (selectedAnswers[0].dataset.product) {
        //fixes free gift undefined bug
        var urlEnd =
          "items[" +
          recommendedProducts.length +
          "][id]=" +
          selectedAnswers[0].dataset.product +
          "&items[" +
          recommendedProducts.length +
          "][quantity]=1"; //This adds the free gift to the first slot
      } else {
        var urlEnd =
          "items[" +
          recommendedProducts.length +
          "][id]=" +
          39794201428101 +
          "&items[" +
          recommendedProducts.length +
          "][quantity]=1"; //This adds the free gift to the first slot
      }
      var url = "/cart/add?";
      var urlFinalArray = "";
      for (var p = 0; p < urlArray.length; p++) {
        var urlFinalArray = urlFinalArray + urlArray[p] + "&"; //final url for sub
        console.log(url);
      }
      url = url + urlFinalArray + urlEnd;
    }
  }

  sessionStorage.setItem("sweatquiz", "true");

  playVideo();
  setTimeout(function () {
    window.location.href = url;
  }, 3300);
}

//Plays a video after quiz completion
function playVideo() {
  document.getElementById("quiz-wrapper").style.backgroundColor = "#FFFFFF";
  document.getElementById("quiz-wrapper").style.width = "100vw";
  if (newQuizVideo === true) {
    document.getElementById("quiz-wrapper").innerHTML =
      '<video width="100%" height="100%" style="width:100vw" autoplay playsinline> <source src="https://cdn.shopify.com/videos/c/o/v/9e911c0550614abebee413098e59915a.mp4" type="video/mp4"></video>';
  } else {
    document.getElementById("quiz-wrapper").innerHTML =
      '<video width="100%" height="100%" style="width:100vw" autoplay playsinline> <source src="https://cdn.shopify.com/videos/c/o/v/7b74b69b232b4114ad6f79ad7e1135dd.mp4" type="video/mp4"></video>';
  }
}

//Timer JS
function startTimerQ() {
  var presentTime = document.getElementById("timerQuiz").innerHTML;
  var timeArray = presentTime.split(/[:]+/);
  sessionStorage.setItem("timerQuizFinal", presentTime);
  var m = timeArray[0];
  var s = checkSecond(timeArray[1] - 1);
  if (s == 59) {
    m = m - 1;
  }

  if (m >= 0) {
    document.getElementById("timerQuiz").innerHTML = m + ":" + s;
  } else {
    document.getElementById("timerQuiz").innerHTML = "0:00";
    return;
  }

  //console.log(m)
  setTimeout(startTimerQ, 1000);
}

function checkSecond(sec) {
  if (sec < 10 && sec >= 0) {
    sec = "0" + sec;
  } // add zero in front of numbers < 10
  if (sec < 0) {
    sec = "59";
  }
  return sec;
}

function previousQuestion(parentID) {
  //console.log(parentID)
  for (i = 0; i < quizQuestions.length; i++) {
    if (quizQuestions[i][0] == parentID) {
      var prevIndex = i - 1;
      for (j = prevIndex; j >= 0; j--) {
        if (quizQuestions[j][1] === true) {
          var prevIndex = j;
          break;
        } else {
        }
      }
    }
  }

  var prevID = quizQuestions[prevIndex][0];
  gtag("event", "quiz_prev_question", { prev: prevID });
  //stores current Q for if page is reloaded
  sessionStorage.setItem("currentQ", prevID);
  history.pushState(null, document.title, location.pathname + "#" + prevID);
  setTimeout(function () {
    document.getElementById(parentID).classList.add("inactive");
    document.getElementById(prevID).classList.remove("inactive");
    window.scrollTo(0, 0);
    //console.log(newIndex);
    //console.log(nextID);

    //HANDLES PROGRESS BAR WIDTH
    var quizLength = quizQuestions.length;
    var progressWidth = ((prevIndex + 1) / quizLength) * 100;
    //console.log(progressWidth);
    document.getElementById("quiz_progress_active").style.width =
      progressWidth + "%";

    //handles show/hide of X button
    if (prevIndex == 0 || prevIndex == quizQuestions.length - 1) {
      document.getElementById("quiz-close-icon").style.opacity = 1;
    } else {
      document.getElementById("quiz-close-icon").style.opacity = 0;
    }
  }, 500);
}

/*window.addEventListener("popstate", function() {
  event.preventDefault();
  previousQuestion(sessionStorage.getItem('currentQ'));
});*/

(function (window, location) {
  window.addEventListener(
    "popstate",
    function () {
      if (quizOpen) {
        if (sessionStorage.getItem("currentQ") == "question_freegift") {
          quizHide();
          console.log(sessionStorage.getItem("currentQ"));
        } else {
          console.log(sessionStorage.getItem("currentQ"));
          previousQuestion(sessionStorage.getItem("currentQ"));
        }
      }
    },
    false
  );
})(window, location);
